import { Link } from '@tanstack/react-router'
import { CatalogGridViewModel } from '@/components/catalog/catalog-grid/catalog-grid.view-model'
import type { useCatalogPageModel } from '@/components/catalog/catalog-page/catalog-page.model'
import { ConversionBandViewModel } from '@/components/shared/conversion-band/conversion-band.view-model'

type CatalogPageViewProps = ReturnType<typeof useCatalogPageModel>

export function CatalogPageView({
  products,
  activeOcasiao,
  pills,
  gridContainerRef,
  isEmpty,
}: CatalogPageViewProps) {
  return (
    <div className="fz-catalog-page">
      <header className="fz-catalog-page__header">
        <h1 className="fz-catalog-page__title">Catálogo</h1>
        <p className="fz-catalog-page__subcopy">
          Cada arranjo carrega uma mensagem — filtre por ocasião e encontre a
          flor certa para dizer o que você sente.
        </p>
      </header>
      <nav className="fz-catalog-page__pills" aria-label="Filtrar por ocasião">
        {pills.map((pill) => {
          const isActive = pill.id === activeOcasiao
          return (
            <Link
              key={pill.id ?? 'todas'}
              to="/catalogo"
              search={{ ocasiao: pill.id }}
              className={
                isActive
                  ? 'fz-catalog-page__pill fz-catalog-page__pill--active'
                  : 'fz-catalog-page__pill'
              }
            >
              {pill.label}
            </Link>
          )
        })}
      </nav>
      {isEmpty ? (
        <div className="fz-catalog-page__empty">
          <p className="fz-catalog-page__empty-text">
            Ainda não temos arranjos cadastrados para esta ocasião.
          </p>
          <Link to="/catalogo" className="fz-catalog-page__empty-link">
            Ver tudo
          </Link>
        </div>
      ) : (
        <div ref={gridContainerRef}>
          <CatalogGridViewModel products={products} />
        </div>
      )}
      <ConversionBandViewModel />
    </div>
  )
}
